export const LogLevel = {
  LOG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

const DefaultLoggerTransport = (logLevel, ...data) => {
  switch (logLevel) {
    case LogLevel.LOG:
      console.log(...data);
      break;
    case LogLevel.INFO:
      console.info(...data);
      break;
    case LogLevel.WARN:
      console.warn(...data);
      break;
    case LogLevel.ERROR:
      console.error(...data);
      break;
  }
};

/**
 * The Logger class provides a simple logging utility that allows you to send messages
 * to a customizable transport mechanism. The class supports different log levels,
 * such as log, info, warn, and error, and can be enabled or disabled globally.
 */
export class Logger {
  static _transport = DefaultLoggerTransport;
  static _isEnabled = true;

  static useTransport(t = DefaultLoggerTransport) {
    Logger._transport = t;
  }

  /**
   * Enables the logger, allowing messages to be logged.
   * By default, the logger is enabled.
   */
  static enable() {
    Logger._isEnabled = true;
  }

  /**
   * Disables the logger, preventing any log messages from being processed.
   */
  static disable() {
    Logger._isEnabled = false;
  }

  /**
   * Logs general information using the LOG log level.
   */
  static log(...data) {
    if (Logger._isEnabled) {
      Logger._transport(LogLevel.LOG, ...data);
    }
  }

  /**
   * Logs informational messages using the INFO log level.
   */
  static info(...data) {
    if (Logger._isEnabled) {
      Logger._transport(LogLevel.INFO, ...data);
    }
  }

  /**
   * Logs warnings using the WARN log level.
   */
  static warn(...data) {
    if (Logger._isEnabled) {
      Logger._transport(LogLevel.WARN, ...data);
    }
  }

  /**
   * Logs error messages using the ERROR log level.
   */
  static error(...data) {
    if (Logger._isEnabled) {
      Logger._transport(LogLevel.ERROR, ...data);
    }
  }
}
